// src/sections/Projects.js
import React, { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebaseConfig/firebase";
import { projects as fallbackProjects } from "../data";
import ProjectModal from "../components/ProjectModal";

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedProject, setSelectedProject] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalProject, setModalProject] = useState(null);

  // Cargar proyectos desde Firestore
  useEffect(() => {
    const loadProjects = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "projects"));
        const loadedProjects = [];
        querySnapshot.forEach((doc) => {
          loadedProjects.push({ id: doc.id, ...doc.data() });
        });

        // Ordenar proyectos: destacados primero
        loadedProjects.sort((a, b) => {
          if (a.featured && !b.featured) return -1;
          if (!a.featured && b.featured) return 1;
          return 0;
        });

        setProjects(loadedProjects.length > 0 ? loadedProjects : fallbackProjects);
      } catch (error) {
        console.error("Error al cargar proyectos:", error);
        setProjects(fallbackProjects);
      } finally {
        setLoading(false);
      }
    };

    loadProjects();
  }, []);

  const handleProjectClick = (project, index) => {
    console.log('Click en proyecto:', project.title, 'Index:', index, 'Seleccionado:', selectedProject);
    if (selectedProject === index) {
      // Si ya está seleccionado, abrir modal
      console.log('Abriendo modal para:', project.title);
      setModalProject(project);
      setModalOpen(true);
    } else {
      // Si no está seleccionado, solo seleccionarlo
      console.log('Seleccionando proyecto:', project.title);
      setSelectedProject(index);
    }
  };

  if (loading) {
    return (
      <section
        id="projects"
        className="min-h-screen bg-black flex items-center justify-center"
      >
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-white"></div>
      </section>
    );
  }

  return (
    <>
      <section id="projects" className="min-h-screen bg-black relative overflow-hidden flex items-center justify-center">
        <div className="relative z-10 w-full h-full">
          {/* Accordion Container */}
          <div className="ac--container">
            {projects.map((project, index) => (
              <figure
                key={project.id}
                className={`ac--figure ${selectedProject === index ? 'ac--figure--active' : ''}`}
                style={{ '--index': index }}
                onClick={() => handleProjectClick(project, index)}
              >
                <img
                  src={project.images.main}
                  alt={project.title}
                  className="ac--image"
                />
                <figcaption className="ac--caption">
                  <div className="ac--caption-content">
                    <h3 className="ac--title">{project.title}</h3>
                    <p className="ac--description">{project.shortDescription}</p>
                    <span className="ac--date">
                      {project.startDate} - {project.endDate || "Presente"}
                    </span>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </section>

      {/* Modal fuera de la sección */}
      <ProjectModal
        project={modalProject}
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </>
  );
};

export default Projects;
